import React from 'react';
import './components/AboutUs.css';

const AboutMortbuzz = () => {
  return (
    <section className="mortbuzz-section-home">
      <div className="mortbuzz-container-home">
        <div className="mortbuzz-text-home">
          <h2>About Mortbuzz Solutions India Pvt. Ltd. - Best Loan Agents In Pune.</h2>
          <p>
            At <strong>MortBuzz</strong>, we are the Best loan consultant in Pune. We strive to provide a seamless and convenient experience to our customers. We provide Home Loan, Personal Loan, Education Loan, Car Loan, Commercial Loan, Business Loan.
            We understand that applying for a loan can be a daunting process, which is why we go above and beyond to make it simple and stress-free.
          </p>
          <p>
            We are committed to providing exceptional personal and business loan support. Whether it's a home loan, personal loan, commercial loan, or loan against property — we are here to help you every step of the way.
          </p>
          <div className="mortbuzz-buttons-home">
            <a href="/apply-now" className="mortbuzz-btn">Apply Now</a>
            <a href="/mortbuzz-home-loan-offer" className="mortbuzz-btn alt">Explore Services</a>
          </div>
        </div>
        <div className="mortbuzz-image-home">
          <img
            src="/images/FrontPage/a-high-fashion-portrait-of-a-young-india_iXMJmzJzSnWhjVmfCPitfw_wTgFyOfrSceM-ko6rRf_kQ.jpeg"
            alt="Mortbuzz loan Agents in Hadapsar Pune"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutMortbuzz;
